"use strict";
var window = require("global");
require("webrtc-adapter/out/adapter_no_edge.js");

module.exports = getBrowserAdapter;

function getBrowserAdapter(){
	if(isNew()) return require("./browser-new");
	return require("./browser");
}

function isNew() {
	var userAgentMatch = window.navigator.userAgent.match(/Chrom(e|ium)\/([0-9]+)\./);
	var chromeVersion = userAgentMatch ? parseInt(userAgentMatch[2], 10) : false;

	// If we're not even running in chrome, don't bother with this fix
	if (!chromeVersion) return false;

	// If we're in a recent version of chrome, don't bother with the fix
	if (chromeVersion >= 65) return true;

	return false;
}